export const withdrawalRequestStatuses: Array<WithdrawalRequestStatus> = [
  {
    id: 'received',
    value: 'received',
    order: 1,
    label: 'Received',
    style: {
      color: 'bg-status-neutral',
      hover: 'hover:bg-status-neutral-active'
    }
  },
  {
    id: 'processing',
    value: 'processing',
    order: 2,
    label: 'Processing',
    style: {
      color: 'bg-status-processing',
      hover: 'hover:bg-status-processing-active'
    }
  },
  {
    id: 'completed',
    value: 'completed',
    order: 3,
    label: 'Completed',
    style: {
      color: 'bg-status-completed',
      hover: 'hover:bg-status-completed-active'
    }
  },
  {
    id: 'cancelled',
    value: 'cancelled',
    order: 4,
    label: 'Cancelled',
    style: {
      color: 'bg-status-negative',
      hover: 'hover:bg-status-negative-active'
    }
  },
  {
    id: 'returned',
    value: 'returned',
    order: 5,
    label: 'Returned',
    style: {
      color: 'bg-status-negative',
      hover: 'hover:bg-status-negative-active'
    }
  },
  {
    id: 'rejected',
    value: 'rejected',
    order: 6,
    label: 'Rejected',
    style: {
      color: 'bg-status-negative',
      hover: 'hover:bg-status-negative-active'
    }
  },
  {
    id: 'pending_approval',
    value: 'Pending_approval',
    order: 7,
    label: 'Pending Approval',
    style: {
      color: 'bg-status-pending',
      hover: 'hover:bg-status-pending-active'
    }
  }
];
export interface TagStyleParams {
  color?: string;
  hover?: string;
}

export type WithdrawalRequestStatus = {
  id: string;
  value: string;
  order: number;
  label: string;
  style: TagStyleParams;
};
